import React from 'react';
import { motion } from 'framer-motion';
import { BadgeCheckIcon, CreditCardIcon, InfinityIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { heroImage, stats } from '../../data/content';
const guarantees = [{
  icon: ZapIcon,
  label: 'Instant Digital Access'
}, {
  icon: CreditCardIcon,
  label: 'One-Time Payment'
}, {
  icon: InfinityIcon,
  label: 'Lifetime Access'
}, {
  icon: ShieldCheckIcon,
  label: '7-Day Money-Back Guarantee'
}];
export function Hero() {
  return <header className="w-full bg-cream" data-id="element-157" data-mp="qu2rv1uhspay">
      <div className="mx-auto max-w-3xl px-5 pb-10 pt-8 sm:pt-12" data-id="element-158" data-mp="vmcfgb84xda2">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="flex flex-col items-center text-center" data-id="element-159" data-mp="vn46d8qsemu0">
          <p className="font-display text-lg font-bold tracking-tight text-navy sm:text-xl" data-id="element-160" data-mp="15ip6108dvb0l">
            Dr. <span className="text-gold-dark" data-id="element-161" data-mp="1ah8rkzj2eksf">Karito</span>
          </p>

          <span className="mt-4 inline-flex items-center gap-1.5 rounded-full border border-navy/15 bg-white px-3 py-1.5 text-[11px] font-bold uppercase tracking-[0.14em] text-navy" data-id="element-162" data-mp="9pdu3mi6o0ep">
            <BadgeCheckIcon className="h-3.5 w-3.5 text-gold-dark" data-id="element-163" data-mp="3vvskx1nwkdi1" />
            Menopause Clinical Blueprint™
          </span>

          <h1 className="mt-5 font-display text-[2rem] font-bold leading-[1.1] tracking-tight text-navy sm:text-5xl" data-id="element-164" data-mp="3rvifpr7xpr48">
            Evaluate, prescribe, and manage Hormone Therapy in under{' '}
            <em className="text-gold-dark" data-id="element-165" data-mp="nfzejfnaciep">5 minutes</em>
          </h1>

          <p className="mt-4 max-w-xl text-[15px] leading-relaxed text-navy/70 sm:text-lg" data-id="element-166" data-mp="infsduaj8eya">
            A step-by-step, evidence-based clinical system. Stop second-guessing
            your treatment decisions or spending valuable time searching through
            multiple guidelines.
          </p>

          <p className="mt-3 max-w-xl text-[14px] leading-relaxed text-navy/60 sm:text-base" data-id="element-167" data-mp="16da242zk1neb">
            Trusted by <strong className="text-navy" data-id="element-168" data-mp="30n8h08on3gna">2,000+ physicians</strong>{' '}
            who want to practice with greater confidence, consistency, and
            clinical clarity.
          </p>
        </motion.div>

        <motion.img initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} src={heroImage} alt="Menopause Clinical Blueprint complete 6-volume system with digital resources" className="mx-auto mt-7 w-full max-w-[34rem]" data-id="element-169" data-mp="2qvuc1ldx5omr" />

        <div className="mt-6" data-id="element-170" data-mp="27xrrpjwbgfva">
          <CTAButton id="hero-cta" variant="navy" label="Get instant access to the complete Blueprint" data-id="element-171" data-mp="27yjnaupwydlk" />
        </div>

        <ul className="mx-auto mt-6 grid max-w-md grid-cols-2 gap-x-3 gap-y-3" data-id="element-172" data-mp="65df90cjk3m9">
          {guarantees.map(item => <li key={item.label} className="flex items-start gap-2 text-left text-[12.5px] font-semibold leading-snug text-navy/75" data-id="element-173" data-mp="b3x2r56s9ngq">
              <item.icon className="mt-0.5 h-4 w-4 shrink-0 text-gold-dark" data-id="element-174" data-mp="1qoftm2nq1pdp" />
              {item.label}
            </li>)}
        </ul>
      </div>

      <div className="border-y border-navy/10 bg-white" data-id="element-175" data-mp="25e508del2lld">
        <dl className="mx-auto grid max-w-3xl grid-cols-2 gap-y-7 px-5 py-8 sm:grid-cols-4" data-id="element-176" data-mp="20lu0bajuezst">
          {stats.map(stat => <div key={stat.label} className="px-1 text-center" data-id="element-177" data-mp="2ebxgbjs4px9t">
              <dt className="font-display text-[1.75rem] font-bold leading-none text-navy sm:text-4xl" data-id="element-178" data-mp="2acoio3tyxf8z">
                {stat.value}
              </dt>
              <dd className="mt-2 text-[11px] font-semibold uppercase leading-tight tracking-[0.1em] text-navy/55" data-id="element-179" data-mp="2o9ligus2e720">
                {stat.label}
              </dd>
            </div>)}
        </dl>
      </div>
    </header>;
}